module.exports = __webpack_public_path__ + "img/sucess-tick.gif";